import { config } from '@/config'

interface SEOInfo {
  title: string
  description: string
  meta: any[]
}

export const getPageSEOInfo = (data: {
  lcid: string
  title: string
  description: string
  path?: string
  cardType?: string
}): SEOInfo => {
  const lcid = (data.lcid || config.locales.default).trim()
  const title = (data.title || '').trim()
  const description = (data.description || '').trim()
  const path = (data.path || '').trim()
  const pageTitle = `${title} - ${config.global.siteName}`
  const siteDomain = `${config.global.siteDomain}`
  const siteUrl = `${config.global.siteUrl}`
  const siteOgType = `${config.global.siteOgType}`
  const siteOgImage = `${config.global.siteUrl}/og-image-${lcid}.webp`
  const siteOgLogo = `${config.global.siteUrl}/og-logo.webp`
  let ogUrl = `${siteUrl}`
  if (path.length > 0) {
    ogUrl = `${ogUrl}${path}`
  }

  const twitterCard = data.cardType || 'summary_large_image'

  return {
    title: pageTitle,
    description,
    meta: [
      // Standard SEO meta tags
      { hid: 'title', name: 'title', content: title },
      { hid: 'description', name: 'description', content: description },

      // Open Graph meta tags
      { hid: 'og:title', property: 'og:title', content: title },
      { hid: 'og:site_name', property: 'og:site_name', content: title },
      {
        hid: 'og:description',
        property: 'og:description',
        content: data.description,
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: siteOgImage,
      },
      {
        hid: 'og:url',
        property: 'og:url',
        content: ogUrl,
      },
      {
        hid: 'og:type',
        property: 'og:type',
        content: siteOgType,
      },
      {
        hid: 'og:logo',
        property: 'og:logo',
        content: siteOgLogo,
      },

      // Twitter Card meta tags
      {
        hid: 'twitter:card',
        name: 'twitter:card',
        content: twitterCard,
      },
      {
        hid: 'twitter:domain',
        name: 'twitter:domain',
        content: siteDomain,
      },
      {
        hid: 'twitter:url',
        name: 'twitter:url',
        content: ogUrl,
      },
      {
        hid: 'twitter:title',
        name: 'twitter:title',
        content: title,
      },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content: description,
      },
      {
        hid: 'twitter:image',
        name: 'twitter:image',
        content: siteOgImage,
      },
    ],
  }
}
